import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import QualityPolicy from './pages/QualityPolicy';
import OurMission from './pages/OurMission';
import OurVision from './pages/OurVision';
import ISO9001 from './pages/ISO9001';
import ISO14001 from './pages/ISO14001';
import ISO45001 from './pages/ISO45001';
import ISO22000 from './pages/ISO22000';
import ISO13485 from './pages/ISO13485';
import ISO27001 from './pages/ISO27001';
import ISO20000 from './pages/ISO20000';
import ISO27701 from './pages/ISO27701';
import ISO16949 from './pages/ISO16949';
import ISO50001 from './pages/ISO50001';
import ISO22301 from './pages/ISO22301';
import ISO37001 from './pages/ISO37001';
import ISO10002 from './pages/ISO10002';
import ISO28001 from './pages/ISO28001';
import ISO22483 from './pages/ISO22483';
import ISO14064 from './pages/ISO14064';
import ISO14046 from './pages/ISO14046';
import ISO31000 from './pages/ISO31000';
import ISO39001 from './pages/ISO39001';
import CECertification from './pages/CECertification';
import BRCCertificate from './pages/BRCCertificate';
import KosherCertificate from './pages/KosherCertificate';
import FSSC22000Certificate from './pages/FSSC22000Certificate';
import ROHSCertificate from './pages/ROHSCertificate';
import AS9100Certificate from './pages/AS9100Certificate';
import GHPCertificate from './pages/GHPCertificate';
import GMPCertificate from './pages/GMPCertificate';
import WRASCertificate from './pages/WRASCertificate';
import Contact from './pages/Contact';
import SystemCertification from './pages/SystemCertification';
import ProductCertification from './pages/ProductCertification';
import QualityCertification from './pages/QualityCertification';
import SearchResults from './pages/SearchResults';
import CertificateQuery from './pages/CertificateQuery';
import CertificateAdmin from './pages/CertificateAdmin';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/quality-policy" element={<QualityPolicy />} />
          <Route path="/our-mission" element={<OurMission />} />
          <Route path="/our-vision" element={<OurVision />} />
          <Route path="/iso-9001" element={<ISO9001 />} />
          <Route path="/iso-14001" element={<ISO14001 />} />
          <Route path="/iso-45001" element={<ISO45001 />} />
          <Route path="/iso-22000" element={<ISO22000 />} />
          <Route path="/iso-13485" element={<ISO13485 />} />
          <Route path="/iso-27001" element={<ISO27001 />} />
          <Route path="/iso-20000" element={<ISO20000 />} />
          <Route path="/iso-27701" element={<ISO27701 />} />
          <Route path="/iso-16949" element={<ISO16949 />} />
          <Route path="/iso-50001" element={<ISO50001 />} />
          <Route path="/iso-22301" element={<ISO22301 />} />
          <Route path="/iso-37001" element={<ISO37001 />} />
          <Route path="/iso-10002" element={<ISO10002 />} />
          <Route path="/iso-28001" element={<ISO28001 />} />
          <Route path="/iso-22483" element={<ISO22483 />} />
          <Route path="/iso-14064" element={<ISO14064 />} />
          <Route path="/iso-14046" element={<ISO14046 />} />
          <Route path="/iso-31000" element={<ISO31000 />} />
          <Route path="/iso-39001" element={<ISO39001 />} />
          <Route path="/ce-certification" element={<CECertification />} />
          <Route path="/brc-certificate" element={<BRCCertificate />} />
          <Route path="/kosher-certificate" element={<KosherCertificate />} />
          <Route path="/fssc-22000" element={<FSSC22000Certificate />} />
          <Route path="/rohs-certificate" element={<ROHSCertificate />} />
          <Route path="/as-9100" element={<AS9100Certificate />} />
          <Route path="/ghp-certificate" element={<GHPCertificate />} />
          <Route path="/gmp-certificate" element={<GMPCertificate />} />
          <Route path="/wras-certificate" element={<WRASCertificate />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/system-certification" element={<SystemCertification />} />
          <Route path="/product-certification" element={<ProductCertification />} />
          <Route path="/quality-certification" element={<QualityCertification />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/certificate-query" element={<CertificateQuery />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/certificate-admin" 
            element={
              <ProtectedRoute>
                <CertificateAdmin />
              </ProtectedRoute>
            } 
          />
        </Routes>
        <Footer />
        <ScrollToTop />
      </div>
    </Router>
  );
}

export default App;

